// Phase 4 — Hook returning the number of unread notifications for
// the current user. "Unread" means the notification's id is greater
// than the last-seen id stored in localStorage (stamped when the
// user opens the Notification Center view).
//
// Subscribes to two refresh triggers:
//   - notifications array changing (new arrivals)
//   - "notif:seen" custom event (user just opened the center)

import { useEffect, useState } from "react";
import { NOTIF_SEEN_KEY, getLastSeenNotifId } from "../views/Notifications";

export function useUnreadNotifications(notifications) {
  const [seenId, setSeenId] = useState(getLastSeenNotifId);

  useEffect(() => {
    const handler = e => setSeenId(Number(e.detail?.id) || 0);
    const storageHandler = e => {
      if (e.key === NOTIF_SEEN_KEY) setSeenId(Number(e.newValue) || 0);
    };
    window.addEventListener("notif:seen", handler);
    window.addEventListener("storage", storageHandler);
    return () => {
      window.removeEventListener("notif:seen", handler);
      window.removeEventListener("storage", storageHandler);
    };
  }, []);

  if (!notifications || notifications.length === 0) return 0;
  let unread = 0;
  for (const n of notifications) {
    if (Number(n.id) > seenId) unread++;
  }
  return unread;
}
